class Frontend {
    constructor() {
        e5.console.log("[eventfive.dialog.bvgs]", "[Frontend]");

        /**
         * NVDA does not fire keydown/keyup it will emulate onClick instead.
         * 
         * @see https://github.com/nvaccess/nvda/issues/7898
         * @see https://github.com/downshift-js/downshift/issues/458
         */
        let mainMenu = document.querySelector("#menu-main-menu");
        if (mainMenu) {
            mainMenu.setAttribute("role", "application");
        }

        /**
         * BeTheme übersetzt die aria-labels leider nicht. Deshalb wird das hier übernommen.
         */
        setTimeout(() => {
            document.querySelectorAll<HTMLAnchorElement>("#menu-main-menu .menu-toggle")
                .forEach((e) => {
                    let label = e.getAttribute("aria-label");
                    const subMenuName = label = label.replace("Toggle submenu ", "");
                    e.setAttribute("aria-label", `Untermenü "${subMenuName}" auf- oder zuklappen`)
                });
        }, 500);

        e5.event.on({
            type: [
                "keyup",
                "keydown"
            ],
            selector: `[data-bvgs-role~="button"]`,
            listener: (e) => {

                if (e.event.type === "keydown") {
                    if (e5.KeyCode.is(e.event, e5.KeyCode.ENTER, e5.KeyCode.SPACE)) {
                        e.event.preventDefault();
                        return;
                    }
                }

                if (e5.KeyCode.is(e.event, e5.KeyCode.ENTER, e5.KeyCode.SPACE)) {
                    e.target.click();
                }
            }
        });

        const setExpanded = (e: HTMLElement, expanded: boolean): boolean => {
            let oldState = e.getAttribute("aria-expanded");
            let newState = expanded ? "true" : "false";
            if (oldState == newState) {
                return expanded;
            }

            e.setAttribute("aria-expanded", newState);

            let event: any = new Event("toggle", {
                bubbles: false,
                cancelable: false,
                composed: true
            });
            event.newState = expanded ? "closed" : "open";
            event.newState = expanded ? "open" : "closed";
            e.dispatchEvent(event);

            return expanded;
        };

        e5.event.on({
            type: "click",
            selector: `[data-bvgs-action~="toggle"][aria-expanded]`,
            listener: (e) => {
                let expanded = setExpanded(e.target, e.target.getAttribute("aria-expanded") !== "true");

                if (expanded && e.target.dataset.bvgsToggleGroup) {
                    document.querySelectorAll<HTMLElement>(
                        `[data-bvgs-action~="toggle"][data-bvgs-toggle-group~="${e.target.dataset.bvgsToggleGroup}"][aria-expanded="true"]`)
                        .forEach((el) => {
                            if (el != e.target) {
                                setExpanded(el, false);
                            }
                        });
                }
            }
        });
    }
}

document.addEventListener("DOMContentLoaded",
    () => {
        new Frontend();
    }
);